import config from "../config.js";
import RequestManager from "./request.js";
import { codeAppliDemandee } from "./appli.js";

// Reinitialisation du mot de passe, cote portail.
//
// Les deux routes vivent dans BackEndParent et servent TOUTES les applications : le lien
// envoye par courriel ramene sur la porte d'entree d'ou vient la demande (login.fisi.fr,
// ag2035.fisi.fr...), determinee par le code d'application transmis ici.
export default class MotDePasse {

    // Demande l'envoi du lien.
    //
    // La reponse est la MEME que l'adresse existe ou non : le backend refuse de dire qui a
    // un compte chez nous, et cet ecran ne doit pas trahir ce qu'il tait. Un « compte
    // inconnu » ferait de cette page un annuaire de nos clients.
    static demanderLien(email) {
        const url = `${config.urlBackEndParent}api/Client/motDePasseOublie`;
        const data = { email: email, appli: codeAppliDemandee() };

        return RequestManager.post(url, data)
            .then(reponse => reponse)
            .catch(erreur => {
                console.error("MotDePasse.demanderLien :", erreur);
                return {
                    success: false,
                    resMsg: "Le service est momentanement injoignable. Reessayez dans un instant."
                };
            });
    }

    // Repose le mot de passe a partir du jeton recu par courriel.
    static reinitialiser(jeton, motDePasse) {
        const url = `${config.urlBackEndParent}api/Client/reinitialiserMotDePasse`;
        const data = { jeton: jeton, motDePasse: motDePasse };

        return RequestManager.post(url, data)
            .then(reponse => reponse)
            .catch(erreur => {
                console.error("MotDePasse.reinitialiser :", erreur);
                return {
                    success: false,
                    resMsg: "Le service est momentanement injoignable. Reessayez dans un instant."
                };
            });
    }
}
